import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminUpsertProviderDepartmentOptionsMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminUpsertProviderDepartmentOptionsMutationResultFragment, AdminUpsertProviderDepartmentOptionsMutationParams } from '@docpace/admin-graphql'

const typedAdminUpsertProviderDepartmentOptionsMutationDocument = AdminUpsertProviderDepartmentOptionsMutationDocument as TypedDocumentNode<AdminUpsertProviderDepartmentOptionsMutationResultFragment, Partial<AdminUpsertProviderDepartmentOptionsMutationParams>>

export function useAdminUpsertProviderDepartmentOptionsMutation(opts?: useMutation.Options<AdminUpsertProviderDepartmentOptionsMutationResultFragment, Partial<AdminUpsertProviderDepartmentOptionsMutationParams>>){
    return useMutation(typedAdminUpsertProviderDepartmentOptionsMutationDocument, opts)
}
